<template>
  <v-expansion-panels flat class="flat-expanssion-panel">
    <v-expansion-panel>
      <v-expansion-panel-header ripple color="grey lighten-4" class="accent--text d-flex align-center justify-content-between">
        <v-tooltip color="white" v-if="contentJson?.lang?.[language]?.text || contentJson?.text" right content-class="tooltip-box-content" max-width="360" :open-delay="300" :close-delay="200" transition="slide-x-transition">
          <template v-slot:activator="{on, attrs}">
            <div v-bind="attrs" v-on="on" style="margin-right: -40px">
              {{ $t("special-zoning-plan") }}
            </div>
          </template>
          <div v-html="contentJson?.lang?.[language]?.text || contentJson?.text"></div>
        </v-tooltip>
        <div v-else>
          {{ $t("special-zoning-plan") }}
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-simple-table dense>
          <template v-slot:default>
            <tbody>
              <TooltipTR section="section400" field="BRAVO_PRI" :label="$t('bravo-pri')">
                <div>
                  <ul class="list-plot-lists">
                    <li v-for="(item, index) in plotItem.BRAVO_PRI_META" :key="index">
                      {{ item.value }}
                      <div v-if="item.area || item.pro">[ {{ item.area }}m² / {{ item.pro }}% ]</div>
                    </li>
                  </ul>
                </div>
              </TooltipTR>
              <TooltipTR section="section400" field="BRAVO_SEC" :label="$t('bravo-sec')">
                <div>
                  <ul class="list-plot-lists">
                    <li v-for="(item, index) in plotItem.BRAVO_SEC_META" :key="index">
                      {{ item.value }}
                      <div v-if="item.area || item.pro">[ {{ item.area }}m² / {{ item.pro }}% ]</div>
                    </li>
                  </ul>
                </div>
              </TooltipTR>
              <TooltipTR section="section400" field="BRAVO_TER" :label="$t('bravo-ter')">
                <div>
                  <ul class="list-plot-lists">
                    <li v-for="(item, index) in plotItem.BRAVO_TER_META" :key="index">
                      {{ item.value }}
                      <div v-if="item.area || item.pro">[ {{ item.area }}m² / {{ item.pro }}% ]</div>
                    </li>
                  </ul>
                </div>
              </TooltipTR>
            </tbody>
          </template>
        </v-simple-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script lang="ts">
import {Component, Prop, Vue} from "vue-property-decorator"
import TooltipTR from "./TooltipText.vue"

@Component({
  components: {TooltipTR},
})
export default class ViewPlotDetails300 extends Vue {
  @Prop()
  plotItem

  get isBravoPrisArray() {
    return Array.isArray(this.plotItem.BRAVO_PRIS)
  }
  get isBravoSecArray() {
    return Array.isArray(this.plotItem.BRAVO_SECS)
  }
  get isBravoTerArray() {
    return Array.isArray(this.plotItem.BRAVO_TERS)
  }

  contentJson: any = {}
  language

  created() {
    this.language = localStorage.getItem("user-language") || "en"
    this.loadTooltip()
  }

  async loadTooltip() {
    this.contentJson = (await this.$store.dispatch("tooltip/getTooltipContent", "section400")) || {}
  }

}
</script>
